/* eslint-disable react/button-has-type */
import classNames from 'classnames/bind';
import { days, get12MonthsFromToday } from 'common/utils';
import { ISearchParams } from 'contexts/searchParams';
import { Dispatch, SetStateAction, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  selectedMonths?: Set<string>;
  closeModal(): void;
  setSearchParams: Dispatch<SetStateAction<ISearchParams>>;
}

export default function DepartureMonth({
  selectedMonths,
  closeModal,
  setSearchParams,
}: IProps) {
  const months = get12MonthsFromToday();
  const [departureMonths, setDepartureMonths] = useState(selectedMonths);

  return (
    <div className={cx('DepartureMonth')}>
      <b className={cx('title')}>출발월</b>
      <ul className={cx('list')} role="listbox">
        <li
          className={cx('item')}
          role="option"
          aria-selected={!departureMonths?.size}
          data-event-nlog="click"
          data-event-area-code="cal.rcdallmonth"
          onClick={() => {
            setDepartureMonths(new Set());
          }}
        >
          <b className={cx('month')}>전체</b>
        </li>
        {months.map(month => (
          <li
            key={month}
            className={cx('item')}
            role="option"
            aria-selected={departureMonths?.has(month)}
            data-event-nlog="click"
            data-event-area-code="cal.rcd12month"
            onClick={() => {
              setDepartureMonths(prev => {
                const updated = new Set(prev);
                if (updated.has(month)) updated.delete(month);
                else updated.add(month);
                return updated;
              });
            }}
          >
            <b className={cx('month')}>{days(month, 'YYYYMM').format('M')}월</b>
            <i className={cx('year')}>
              {days(month, 'YYYYMM').format('YYYY')}년
            </i>
          </li>
        ))}
      </ul>
      <div className={cx('btns')}>
        <button
          className={cx('cancel')}
          data-event-nlog="click"
          data-event-area-code="cal.rcddelmonth"
          onClick={closeModal}
        >
          취소
        </button>
        <button
          className={cx('search')}
          data-event-nlog="click"
          data-event-area-code="cal.rcdapplymonth"
          onClick={() => {
            setSearchParams(prev => ({ ...prev, departureMonths }));
            closeModal();
          }}
        >
          적용
        </button>
      </div>
    </div>
  );
}
